import { CURRENT_ADMIN_SUB_TAB, CURRENT_ADMIN_SUB_TAB_CONTAINER, CURRENT_ADMIN_TAB } from "../constants/adminSideMenuConstants"


export const getCurrentTab = (tab) => async(dispatch) => {
    dispatch ({
        type: CURRENT_ADMIN_TAB,
        payload: tab
    })
}

export const getCurrentSubTab = (subTab) => async(dispatch) => {
    dispatch ({
        type: CURRENT_ADMIN_SUB_TAB,
        payload: subTab
    })
}

export const getCurrentSubTabContainer = (container) => async(dispatch) => {
    dispatch ({
        type: CURRENT_ADMIN_SUB_TAB_CONTAINER,
        payload: container
    })
}